export function formatDate(input) {
  const [day, month, year] = input.split('/');
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
  // .replace(/, /g, ' ');
}

export function customFormatDate(input) {
  const [day, month, year] = input.split('/');
  const date = new Date(year, month - 1, day);

  const monthAbbr = date.toLocaleDateString('en-US', { month: 'short' });
  return `${date.getDate()} de ${monthAbbr}, ${date.getFullYear()}`;
}
